import { createAction } from 'redux-actions';

import { SET_NEW_CASE_NUMBER } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const setNewCaseNumber = createAction(SET_NEW_CASE_NUMBER);



// WEBPACK FOOTER //
// ./src/redux/cases/actions.js